import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/admin/insights/")({
  beforeLoad: () => {
    throw redirect({ to: "/insights", replace: true });
  },
});
